import { Job } from '@/core/entity';
import { IFileGateway, IJobGateway, JobInput, PresenterFunc } from '@/core/interface';
import { Fragment, UpdaterFunc } from '@/core/interface/common';
import { JobService } from '@/core/usecase';
import {from} from 'apollo-link';

export class JobController {
  private readonly service: JobService;

  constructor(
    fileGw: IFileGateway,
    jobGw: IJobGateway,
  ) {
    this.service = new JobService(fileGw, jobGw);
  }

  public create(
    input: JobInput,
    file: File | null,
    presenter: PresenterFunc<Job | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    this.service.createJob(input, file, presenter, fragment, updater);
  }

  public remove(
    id: string,
    presenter: PresenterFunc<Job | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
    refetchQueries?: string[],
  ) {
    this.service.removeJob(id, presenter, fragment, updater, refetchQueries);
  }

  public getImages(id: string, fromEmail: string, presenter: PresenterFunc<boolean | null>) {
    this.service.getImages(id, fromEmail, presenter);
  }
}
